<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                This is a reusable snackbar component.<br/>
                It's set up so that it will be available to us on every page.</br>
                Typically, you'll invoke it by referencing a property defined on the <code>$root</code> Vue component.
                Pressing the buttons below should invoke it with some of its varying options.
            </v-card-text>
            <v-card-actions>
                <v-btn @click="success">
                    Success
                </v-btn>
                <v-btn @click="warning">
                    Warning
                </v-btn>
                <v-btn @click="error">
                    Error
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "ExampleSnackbar",
    components: {
        AppLayout,
        SmartTable
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
        }
    },
    methods: {
        success() {
            this.$root.snackbar.success('success')
        },
        warning() {
            this.$root.snackbar.warning('warning')
        },
        error() {
            this.$root.snackbar.error('error')
        },
    },
}
</script>

<style>

</style>
